export enum PaymentStatus {
    Approved = 'approved',
    Declined = 'declined',
}

export enum PaymentProvider {
    Okto = 'okto',
    Nuvei = 'safecharge',
    Paybrokers = 'paybrokers',
}
